module.exports = __webpack_public_path__ + "static/canadian-natural-resources-limited-logo-f58c060c6d1d0480229c61560d3e5178.jpg";